import Image from "next/image";
import GradientTextWithBall from "./common/GradientTextWithBall";
import SpaceWrapper from "./common/SpaceWrapper";

const AboutSection = () => (
  <SpaceWrapper className="!p-0">
    <div className="pt-20 px-8 md:px-4 xl:pt-32 xl:px-48 bg-gradient-roaddy-about">
      <GradientTextWithBall
        text={
          <>
            About
            <br />
            The Project
          </>
        }
      />
      <div className="mt-6 xl:mt-0 pt-2 xl:pt-0">
        <p className="text-justify text-white text-lg xl:mt-24">
          <span className="font-gilroy">
            Traveling via bike and visiting new places is fun until your bike
            breaks down in the middle of nowhere. In such a scenario, you can do
            one of the two, either try to fix the issue yourself or call for
            help. Often people need their vehicles to be towed to the nearest
            repair station. But how would you do that? Searching online may find
            you some road assistance services, but they may not be beneficial.
            This is when a road assistance mobile app comes in handy. Feeling
            stuck and anxious in a situation where your bike breaks down is
            pretty normal. But instead of worrying or requesting people for
            help, you can simply use a road assistance app and get professional
            help immediately.
          </span>
        </p>
      </div>
    </div>
    <div>
      <div className="overflow-hidden">
        <p className="font-bold text-[141px] xl:text-[312px] bg-clip-text text-transparent bg-gradient-roaddy-marquee-text animate-right-to-left text-nowrap mb-20">
          <span>THE PROJECT</span>
        </p>
        <div className="flex justify-center relative z-10 bottom-48 xl:bottom-[17rem]">
          <Image
            alt="Roadside service assistance mobile app, login screen  and homepage"
            loading="lazy"
            src="/assets/case-study/roaddy/couples-of-phone.webp"
            width={1490}
            height={902}
          />
        </div>
        <div className="bg-roaddy-about-image h-40 md:h-80 xl:h-[48rem] bg-contain -mt-48 xl:-mt-[40rem] bg-no-repeat"></div>
      </div>
    </div>
  </SpaceWrapper>
);
export default AboutSection;
